export enum OnboardingStep {
  wellbeing = "wellbeing",
  trackMood = "track-mood",
  digestMedia = "digest-media",
  trackFeelings = "track-feelings",
  emergencyContacts = "emergency-contacts",
}
